import { appApi } from '../../api/app.api'
import { PAPER_TYPE, BACK_MOCK_TYPE, BACK_REAL_TYPE } from '../../utils/constants.util'

export const getUserByType = (type) => {
  const methods = {
    [PAPER_TYPE]: appApi.getPapertestingUser,
    [BACK_MOCK_TYPE]: appApi.getBacktestingMockUser,
    [BACK_REAL_TYPE]: appApi.getBacktestingRealUser
  }

  return methods[type]()
}
